module.exports = __webpack_public_path__ + "681865a8b19bbf7a86ee68825106de3f.png";